import { PermissionV2 } from './role';

export interface OrganizationRoleV2 {
  id: string;
  name: string;
  memberCount: number;
  permissions: PermissionV2[];
}

export interface OrganizationMemberV2 {
  id: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  role: { id: string; name: string } | null;
}

export interface OrganizationRolePayload {
  name: string;
  permissionIds: string[];
}

export interface AddOrganizationMemberPayload {
  phone: string;
  roleId: string;
}

/** Whose team: the caller's own organization, or any organization (staff). */
export type TeamScope = { kind: 'my' } | { kind: 'org'; orgId: string };

export const MY_TEAM: TeamScope = { kind: 'my' };

export const teamScopeKey = (scope: TeamScope): string =>
  scope.kind === 'my' ? 'my' : scope.orgId;

export interface OrganizationTeamSummaryV2 {
  id: string;
  name: string;
}

/** Staff add a member they picked on User Details. */
export interface AddOrganizationMemberByUserPayload {
  userId: string;
  roleId: string;
}
